// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__JVheO","container":"styles_container__1xHL2","title":"styles_title__2i9nU","wrapper":"styles_wrapper__1m-Te","answer":"styles_answer__uZ4fP"};